import { createFileRoute } from '@tanstack/react-router'

import LecturePage from '@/lecture/components/LecturePage/LecturePage'

export const Route = createFileRoute(
  '/_learning/lectures/$topic/{-$lecture}/{-$suffix}/{-$id}',
)({
  component: LecturePage,
})
